module.exports = {
  API_ROOT: 'https://racingmax2023-referrer.backend.pre.next-insur.tech'
}
